<div class="field-editor" (keydown)="onKeydown($event)">
  <div class="field-editor-label">{{ label }}</div>
  <div class="period-fields">
    <label class="period-field">
      <span class="field-editor-label">{{ 'cv.tailor.edit.periodStart' | translate }}</span>
      <input nbInput fullWidth type="month" placeholder="YYYY-MM" [(ngModel)]="draftStart" [disabled]="busy" (ngModelChange)="onInput()">
    </label>
    <label class="period-field">
      <span class="field-editor-label">{{ 'cv.tailor.edit.periodEnd' | translate }}</span>
      <input nbInput fullWidth type="month" placeholder="YYYY-MM" [(ngModel)]="draftEnd" [disabled]="busy || current" (ngModelChange)="onInput()">
    </label>
  </div>
  <nb-checkbox [checked]="current" [disabled]="busy" (checkedChange)="current = $event; onInput()">{{ 'cv.tailor.edit.periodCurrent' | translate }}</nb-checkbox>
  @if (error) {
    <div class="period-error">{{ ('cv.tailor.edit.period.' + error) | translate }}</div>
  }
  <div class="field-editor-footer">
    <span class="field-editor-count"></span>
    <div class="field-editor-actions">
      <button nbButton ghost size="tiny" status="basic" type="button" [disabled]="busy" (click)="onCancel()">
        {{ 'cv.tailor.edit.cancel' | translate }}
      </button>
      <button nbButton size="tiny" status="primary" type="button" [disabled]="!isDirty || !!error || busy" [nbSpinner]="busy" nbSpinnerStatus="control" (click)="onSave()">
        {{ 'cv.tailor.edit.save' | translate }}
      </button>
    </div>
  </div>
</div>
